import moment from "moment";
import { axios } from "../connection/ConnectionHandler";
import { createCrudActions } from '../utils/crudGenerator';
import { SHOW_NOTIFICATION } from "../constants";

const formatContainermeasurements = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => {
        const formattedItem = {
            ...item,
            label: `${item.name}`,
            value: item._id,
            measurementDate: item.measurementDate && moment(item.measurementDate),
        };

        return formattedItem;
    };

    if (Array.isArray(data)) {
        const result = data.map(formatItem);
        return result;
    }
    return formatItem(data);
};

// Función personalizada para crear mediciones que maneje actualizaciones automáticas
const createContainermeasurementCustom = (newEntity) => async (dispatch) => {
    try {
        dispatch({ type: 'CONTAINERMEASUREMENT_FORM_TOGGLE_LOADING' });
        const response = await axios.post('containermeasurement', newEntity);
        const formattedData = formatContainermeasurements(response.data);

        // Determinar si se creó o actualizó basado en el campo _action
        const actionType = response.data._action === 'updated' ? 'UPDATE_CONTAINERMEASUREMENT' : 'ADD_NEW_CONTAINERMEASUREMENT';

        dispatch({ type: actionType, payload: formattedData });
        dispatch({ type: 'CONTAINERMEASUREMENT_FORM_TOGGLE_LOADING' });

        const message = response.data._action === 'updated'
            ? 'Medición actualizada con éxito.'
            : 'Medición creada con éxito.';

        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                show: true,
                status: "success",
                message: message,
            },
        });
        return response.status;
    } catch (err) {
        dispatch({ type: 'CONTAINERMEASUREMENT_FORM_TOGGLE_LOADING' });
        return err;
    }
};

export const {
    fetch: fetchContainermeasurements,
    create: createContainermeasurement,
    update: updateContainermeasurement,
    delete: deleteContainermeasurements
} = createCrudActions('CONTAINERMEASUREMENT', "Medicion", formatContainermeasurements);

// Reemplazar la función create con la personalizada
export const createContainermeasurementWithAutoUpdate = createContainermeasurementCustom;
